import Select from 'react-select'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ToggleField from '../FormLegacy/FormFieldsV2/ToggleField'

import { escalationTimerOptions } from './helper'

const EscalationSettings = ({
  selectedTimerOption,
  setSelectedTimerOption,
  isAfterBusinessHours,
  setAfterBusinessHours,
  priorityLevelsOptions,
  selectedPriorityLevels,
  setSelectedPriorityLevels,
}) => {
  const { t } = useTranslation(['on-call-schedule'])
  const itemWrapStyle = { flex: 1 }
  return (
    <div className="on-call-schedule__escalations-tab-settings">
      <div style={itemWrapStyle}>
        <h4 className="on-call-schedule__escalations-tab-settings-title">
          {t('on-call-schedule:escalationSettings.timerTitle')}
        </h4>
        <p className="on-call-schedule__escalations-tab-settings-text">
          {t('on-call-schedule:escalationSettings.timerDescription')}
        </p>
        <Select
          className="select-container"
          classNamePrefix="select-primary"
          options={escalationTimerOptions}
          value={selectedTimerOption}
          onChange={(option) => setSelectedTimerOption(option)}
        />
      </div>
      <div className="on-call-schedule__escalations-tab-settings-divider" />
      <div style={itemWrapStyle}>
        <h4 className="on-call-schedule__escalations-tab-settings-title">
          {t('on-call-schedule:escalationSettings.afterHoursTitle')}
        </h4>
        <p className="on-call-schedule__escalations-tab-settings-text">
          {t('on-call-schedule:escalationSettings.afterHoursDescription')}
        </p>
        <ToggleField
          name="afterBusinessHours"
          value={isAfterBusinessHours}
          onChange={() => setAfterBusinessHours((prev) => !prev)}
          label={t('on-call-schedule:escalationSettings.afterHoursToggleLabel')}
          labelOnRight
        />
      </div>
      <div className="on-call-schedule__escalations-tab-settings-divider" />
      {!!priorityLevelsOptions.length && (
        <div style={itemWrapStyle}>
          <h4 className="on-call-schedule__escalations-tab-settings-title">
            {t('on-call-schedule:escalationSettings.priorityTitle')}
          </h4>
          <p className="on-call-schedule__escalations-tab-settings-text">
            {t('on-call-schedule:escalationSettings.priorityDescription')}
          </p>
          <Select
            value={selectedPriorityLevels.length ? selectedPriorityLevels : null}
            className="select-container"
            classNamePrefix="select-primary"
            placeholder={t('on-call-schedule:escalationSettings.priorityPlaceholder')}
            options={priorityLevelsOptions}
            isMulti
            onChange={(params) => {
              setSelectedPriorityLevels(params)
            }}
          />
        </div>
      )}
    </div>
  )
}

EscalationSettings.propTypes = {
  selectedTimerOption: PropTypes.object.isRequired,
  setSelectedTimerOption: PropTypes.func,
  isAfterBusinessHours: PropTypes.bool,
  setAfterBusinessHours: PropTypes.func,
  priorityLevelsOptions: PropTypes.array,
  selectedPriorityLevels: PropTypes.array,
  setSelectedPriorityLevels: PropTypes.func,
}

export default EscalationSettings
